module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui search"
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('input', {
    staticClass: "prompt",
    attrs: {
      "type": "text",
      "placeholder": _vm.single ? 'Choose a Wiki' : 'Add another Wiki'
    },
    domProps: {
      "value": _vm.wiki
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search icon"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d7f12dd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WikiSelector.vue
// module id = 399
// module chunks = 1